import { Component, Input, OnInit, HostListener, ViewChild, ElementRef, AfterViewInit, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { commonService } from "../../service/common.service";
import { Http, ResponseContentType } from '@angular/http';
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { Location } from '@angular/common';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { slideIn } from './animation';

@Component({
  selector: 'app-studentreport',
  templateUrl: './studentreport.component.html',
  styleUrls: ['./studentreport.component.css'],
  providers: [TestSeriesService],
  animations: [slideIn]
})
export class StudentreportComponent implements OnInit, AfterViewInit {
  tabSet: any;
  @ViewChild('test') el: ElementRef;
  @ViewChild(NgbTabset) set content(content: ViewContainerRef) {
    this.tabSet = content;
  };
  typetxt: any = '';
  notfound: any;
  isPostLoad = true;
  msg: any = '';
  userData: any;
  isError = false;
  siteUrl = this.global.websiteUrl;
  isMyPackage = false;
  streamText: any = '';
  testSeriesbox: any;
  testPaperbox: any;
  testSeriesId = 0;
  testAnswerUploadStructures: any;
  testPaperId = 0;
  testData: any;
  testPaperStructures: any;
  comment: any;
  activeIdString: any;
  totalStudends: any;
  studendRank: any;
  topRanker: any;
  topTen: any;
  abc = '';
  isBackButton = false;
  allPackageList: any = [];
  disabled = true;
  percentDone = 0;
  offlinetopperslist: any;
  onlinetopperslist: any;
  notoffline = true;
  offline = false;
  //slideInState = 'in';
  topperCopy :any;
  copyurl = this.global.testseriesImageUrl;

  constructor(private cdRef: ChangeDetectorRef, private http: HttpClient, private _location: Location, private testseriesservice: TestSeriesService, private router: Router, private route: ActivatedRoute, private global: Globals, private commonService: commonService) {
    this.topTen = [];
    this.totalStudends = {};
    this.studendRank = {};
    this.allPackageList = [];
    this.topperCopy=[];

    this.commonService.profile.subscribe((data: any) => {
      if (data) {
        this.userData = data;
      } else {
        this.userData = {};
      }
    });

    //this.gettestpaperdropdownlist();
  }

  ngAfterViewInit() { // on click of test paper from my packages page, make active 'rank wise report' tab. 
    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.tabSet.select('static-2');
      }
    });
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.testPaperId = parseInt(params['id']);
        this.isBackButton = true;
        this.disabled = false;
        if (isNaN(this.testPaperId)) {
          this.testPaperId = 0;
        }
        let filter = {};
        filter['testPaperId'] = this.testPaperId;
        filter['studentId'] = (this.userData.id) ? this.userData.id : 0;
        this.getPapersReportSummery(filter);

      }
    });

    this.getTestSeriesList();
    this.getAllReportList();
  }


  filterform(searchtxt) {
    this.isPostLoad = true;
    this.disabled = false;
    this.isBackButton = true;
    this.testPaperId = searchtxt.value.testPaperId.trim();
    //this.testSeriesId = searchtxt.value.testSeriesId.trim();
    let filter = {};
    filter['testPaperId'] = this.testPaperId;
    filter['studentId'] = (this.userData.id) ? this.userData.id : 0;
    this.getPapersReportSummery(filter);
  }

  getTestSeriesList() {
    var obj = {};
    obj['Stype'] = 'status';
    // obj['streamId'] = this.streamId;
    obj['studentId'] = (this.userData.id) ? this.userData.id : 0;
    this.testseriesservice.getreportmainstslist(obj).subscribe((data: any) => {
      if (data.error == 0) {
        this.testSeriesbox = data.results;
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/admin']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
      });

  }

  onTPChange(event: any) {
    this.testSeriesId = event.target.value;
    this.gettestpaperdropdownlist();
  }

  gettestpaperdropdownlist() {
    var obj = {};
    obj['testSeriesId'] = this.testSeriesId;

    this.testseriesservice.gettestpaperdropdownlist(obj).subscribe((data: any) => {
      if (data.error == 0) {
        this.testPaperbox = data.results;
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/admin']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
      this.isPostLoad = false;
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
        this.isPostLoad = false;
      });

  }

  combineArray(array1, array2) {
    return [].concat(array1, array2);
  }

  getPapersReportSummery(obj) {
    this.testseriesservice.getStudentDetailedReport(obj).subscribe((data: any) => {

      if (data.error == 0) {
        //this.topTen = data.results.topTen;
        let toptenlist = data.results.topTen;
        this.totalStudends = data.results.totalStudentCount[0];
        this.studendRank = data.results.studendRank[0];
        this.offlinetopperslist = data.results.offlinetoppers;
        this.onlinetopperslist = data.results.onlinetoppers;

        this.topTen = this.combineArray(toptenlist, this.onlinetopperslist);
        this.topTen = this.topTen.sort(function (a, b) {
          return b.totalMarks - a.totalMarks;
        });

        this.topperCopy = data.results.toppercopy;
        
        if (this.offlinetopperslist.length > 0) {
          this.notoffline = false;
          this.offline = true;
        }

        this.notfound = false;
        this.isError = false;
        this.isPostLoad = false;

        //console.log('6666',this.studendRank,this.topTen,this.totalStudends);
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
        this.notfound = true;
        this.isPostLoad = false;
        this.topTen = [];
        this.totalStudends = {};
        this.studendRank = {};

      }
    }, (error: HttpErrorResponse) => {
      this.isPostLoad = false;
      this.isError = true;
      this.msg = "internal server error!";
    });
  }

  getpercentile(yourRank, totalcount) {

    /* let rr:any;
    rr = (yourRank*100)/totalcount;
     return  Number(100 - parseFloat(rr)).toFixed(2);*/
    let rr: any;
    rr = totalcount - yourRank;
    return Number((rr / totalcount) * 100).toFixed(2);
  }

  getpercent(yourRank, totalmarks) {
    return Number((yourRank * 100) / totalmarks).toFixed(2);
  }

  backClicked() {
    this._location.back();
  }

  getAllReportList() {
    let obj = {};
    obj["status"] = "completed";
    obj["userId"] = (this.userData.id) ? this.userData.id : 0;
    obj["limit"] = 10;
    obj["offset"] = 0;
    this.testseriesservice.getAllReportList(obj).subscribe((data: any) => {

      if (data.error == 0) {
        this.allPackageList = data.results.rows;
        console.log(this.allPackageList)
        this.isError = false;
        this.isPostLoad = false;

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
        this.isPostLoad = false;
        this.allPackageList = [];


      }
    }, (error: HttpErrorResponse) => {
      this.isPostLoad = false;
      this.isError = true;
      this.msg = "internal server error!";
    });
  }

  getReortDetailPageUrl(id) {
    return (this.isBackButton) ? './../' + id : './' + id;
  }
  getpaperCountByType(type, arr) {
    let i = 0;
    if (arr) {
      for (let index of arr) {
        if (index.testAnswerUpload && index.testAnswerUpload.status == type) i++;
      }
    }
    return i;
  }

  testseriesImageUrl(imagename) {
    imagename = (imagename != '') ? imagename : 'ts_demo.jpg';
    return this.global.testseriesImageUrl + imagename;
  }

  getPaperStatus(status) { //console.log('status',status);
    let st = '';
    switch (status) {
      case 'Pending': st = 'Uploaded but not Assigned to Faculty';
        break;
      case 'Assigned': st = 'Under Evaluation';
        break;
      case 'Completed': st = 'Completed';
        break;
      default: st = 'Not Uploaded';
    }
    return st;
  }

  downloadAttachment(fileName) {

    var downloadurl = this.global.tsAnsImageUrl + fileName;
    this.percentDone = 0;

    const req = new HttpRequest('GET', downloadurl, {
      reportProgress: true,
      responseType: 'blob'
    });

    this.http.request(req).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          console.log('Request sent!');
          break;
        case HttpEventType.ResponseHeader:
          console.log('Response header received!');
          break;
        case HttpEventType.DownloadProgress:
          this.percentDone = Math.round(100 * event.loaded / event.total);
          console.log(this.percentDone);
          break;
        case HttpEventType.Response:
          console.log('Done!', event);
          let file = event.body;
          console.log(file.size + " bytes file downloaded. File type: ", file.type);
          // create and download link
          var url = window.URL.createObjectURL(file);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element */

      }

    }, error => {
      if (error.status = "404") {
        alert('Something went wrong. Please try to latter.');
        this.percentDone = 0;
      }
    }, () => {
      this.percentDone = 0;
    });

  }




}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/studentreport/studentreport.component.ts